// ======================================================================
// File Name       : ServiceGroupSuperUserRelation
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Table, Form } from 'react-bootstrap';

class ServiceGroupSuperUserRelation extends Component {
  render() {
    const { editingServiceGroupSuperUser } = this.props;
    const editingServiceGroup = Object.keys(editingServiceGroupSuperUser).sort((a, b) => {
      if (editingServiceGroupSuperUser[a].addNew && !editingServiceGroupSuperUser[b].addNew) {
        return -1;
      } if (!editingServiceGroupSuperUser[a].addNew && editingServiceGroupSuperUser[b].addNew) {
        return 1;
      }
      if (editingServiceGroupSuperUser[a].index < editingServiceGroupSuperUser[b].index) {
        return -1;
      } if (editingServiceGroupSuperUser[a].index > editingServiceGroupSuperUser[b].index) {
        return 1;
      }
      return 0;
    });
    return (
      <Form.Group>
        <Col className="margin-left-15 margin-bottom-5 margin-top-30" sm={12}>所属管理ユーザー</Col>
        <Col sm={12}>
          <Table striped hover className="margin-top-7 margin-bottom-0 margin-left-15">
            <thead>
              <tr>
                <th>管理ユーザー名</th>
                <th>ログインID</th>
              </tr>
            </thead>
            <tbody>
              {editingServiceGroup.map((userSecernId, index) => {
                const data = editingServiceGroupSuperUser[userSecernId]
                  ? editingServiceGroupSuperUser[userSecernId]
                  : {};
                return (
                  <tr key={index}>
                    <td>{data.superuserName || ''}</td>
                    <td>{data.loginId || ''}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Form.Group>
    );
  }
}

ServiceGroupSuperUserRelation.propTypes = {
  editingServiceGroupSuperUser: PropTypes.shape().isRequired,
};

export default ServiceGroupSuperUserRelation;
